// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProductSlider_wrapper__IdWfT","slider":"ProductSlider_slider__H7IwO","header":"ProductSlider_header__xLupz","title":"ProductSlider_title__1ovZQ"};